// Actions
export const API_KEY_RESPONSE_SUCCESS = "API_KEY_RESPONSE_SUCCESS";
export const API_KEY_RESPONSE_ERROR = "API_KEY_RESPONSE_ERROR";
export const GET_API_KEY = "GET_API_KEY";
